/* @flow */

import type { CmsPage } from "shop-state/types";

import React from "react";
import { Helmet } from "react-helmet-async";
import Wrapper from "components/Wrapper";
import Breadcrumbs from "components/Breadcrumbs";
import { useGetCmsMeta } from "helpers/get-meta";
import styles from "./styles.scss";

type Props = {
  cmsPage: CmsPage,
  showBreadcrumbs?: boolean,
};

const CmsPageView = ({ cmsPage, showBreadcrumbs = true }: Props): React$Node => {
  const meta = useGetCmsMeta(cmsPage);

  return (
    <Wrapper className={styles.wrapper}>
      <Helmet
        title={meta.title}
        meta={meta.data}
        link={meta.link}
      />

      {showBreadcrumbs &&
        <Breadcrumbs current={cmsPage.contentHeading} />
      }

      <h1>{cmsPage.title}</h1>

      <div key={cmsPage.url} dangerouslySetInnerHTML={{ __html: cmsPage.content }} className="typography" />
    </Wrapper>
  );
};

export default CmsPageView;
